import { render, staticRenderFns } from "./simpleUsers.vue?vue&type=template&id=3745c0d8&"
import script from "./simpleUsers.vue?vue&type=script&lang=js&"
export * from "./simpleUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports